import { createSelector } from 'reselect';

const substate = (state) => state.product;

export const selectProducts = () => createSelector(substate, (contextState) => contextState.products);
